import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Navigate, Route, Routes } from "react-router-dom";
import "../src/Css/global.css";
import "./App.css";
import Home from "./Components/Home";
import Loader from "./Components/Loder";
import Login from "./Components/Login";
import NotFound from "./Components/NotFound";
import AppContext from "./Context/AppContext";
import { SecurityAccessManager } from "./Security/SecurityAccessManager";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(sessionStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("dashBoard");
  const [session, setSession] = useState(
    JSON.parse(sessionStorage.getItem("sessiondata"))
  );
  const [user, setUser] = useState({});
  const [isSessionExpeired, setisSessionExpeired] = useState(false);
  const [entitlements, setEntitlements] = useState(
    sessionStorage.getItem("entitlements")
  );

  const logoutHandler = () => {
    setIsAuthenticated(false);
    setActiveTab("");
    sessionStorage.clear();
  };

  const isAuth = sessionStorage.getItem("isAuth");

  useEffect(() => {
    SecurityAccessManager.initEntitlements();
  }, []);

  const PrivateRoute = ({ element }) => {
    if (isAuth) {
      return (
        <AppContext.Provider
          value={{
            isLoading,
            setIsLoading,
            activeTab,
            setActiveTab,
            session,
            setSession,
            user,
            setUser,
            token,
            setToken,
            isSessionExpeired,
            setisSessionExpeired,
            logoutHandler,
            entitlements,
            setEntitlements,
          }}
        >
          {element}
        </AppContext.Provider>
      );
    } else {
      return <Navigate to="/login" />;
    }
  };

  return (
    <div className="app">
      <Routes>
        <Route
          path="/"
          element={
            <Login
              setIsAuthenticated={setIsAuthenticated}
              token={token}
              setToken={setToken}
              setSession={setSession}
              setUser={setUser}
              setisSessionExpeired={setisSessionExpeired}
              setEntitlements={setEntitlements}
            />
          }
        ></Route>
        <Route
          path="/login"
          element={
            <Login
              token={token}
              setIsAuthenticated={setIsAuthenticated}
              setToken={setToken}
              setSession={setSession}
              setUser={setUser}
              setisSessionExpeired={setisSessionExpeired}
              setEntitlements={setEntitlements}
            />
          }
        ></Route>
        <Route
          path="/home"
          element={
            <PrivateRoute element={<Home logoutHandler={logoutHandler} />} />
          }
        ></Route>
        <Route path="*" element={<NotFound />} />
        {/* <Route path="/products/:slug" element={<ProductDetails />} /> */}
      </Routes>
      {isLoading ? <Loader /> : null}
    </div>
  );
}

export default App;
